@use "variables" as *;

.indentedText {
  margin-left: $spacing-xl;
}

.imageFloatRight {
  float: right;
  margin-left: $spacing-m;
}
